import React from 'react';
import moment from 'moment';
import ActionLink from 'components/elements/molecules/ActionLink/ActionLink';
import RectangularButton from 'components/elements/molecules/RectangularButton/RectangularButton';
import { Icon, ICONS } from '../../Icons';

export default function SyllabusUploadStepFinal({
  rows,
  course,
  deliveryPreferences,
  syllabusData,
  onDone,
  onMinimize,
  onAdjustSettings,
  isScheduledConfirmed = false,
}) {
  const syllabus = syllabusData?.syllabus || syllabusData || {};
  const count = rows.length;
  const deliveryDay = deliveryPreferences?.deliveryDay || 'Sunday';

  const dates = rows
    .map((r) => r.date)
    .filter(Boolean)
    .sort();
  const firstDeliveryDate = dates.length
    ? moment(dates[0]).subtract(1, 'day').format('MMM D')
    : null;

  const bullets = [
    {
      text: `On ${deliveryDay}s, we’ll email you suggested articles for the upcoming week.`,
      subText: firstDeliveryDate
        ? `First suggestions arrive ${deliveryDay}, ${firstDeliveryDate}`
        : null,
    },
    {
      text: 'You then review and publish to students.',
    },
    {
      text: (
        <>
          <ActionLink
            label="Adjust your settings"
            onClick={onAdjustSettings}
            linkClassName="font-weight-600 av-blue"
          />{' '}
          at any time.
        </>
      ),
      subText: 'Change delivery day, skip weeks, or pause from Settings.',
    },
  ];

  return (
    <div className="syllabus-step">
      <div className="main-con">
        <div className="modal-header">
          <div className="syllabus-step-title">
            You’ve connected your course lectures to recent news articles.
          </div>
          <p className="syllabus-step-desc mt-1">
            {count} lecture week{count !== 1 ? 's' : ''} configured
          </p>
        </div>
        <div className="section-con">
          <ul className="syllabus-step3-bullets">
            {bullets.map(({ text, subText }, i) => (
              <li key={i} className="syllabus-step3-bullet">
                <Icon icon={ICONS.CHECK} className="syllabus-step3-check" />
                <div>
                  <span>{text}</span>
                  {subText && (
                    <p className="syllabus-step3-bullet-sub">{subText}</p>
                  )}
                </div>
              </li>
            ))}
          </ul>
        </div>
        <div className="syllabus-step-footer">
          <div />
          <RectangularButton
            darkButton
            onClick={!isScheduledConfirmed ? onMinimize : onDone}
          >
            {!isScheduledConfirmed ? 'Minimize' : 'Done'}
          </RectangularButton>
        </div>
      </div>
    </div>
  );
}
